import moment from 'moment'

export function errorFetching (state, value) {
  state.errorFetching = value
}

export function loading (state, value) {
  state.loading = value
}

export function setAltitude (state, value) {
  state.altitude = value
}

export function setHead (state, { head, from = null }) {
  state.headFrom = from
  if (head > 360) {
    head -= 360
  } else if (head < -360) {
    head += 360
  }
  if (head < 0) {
    head += 360
  }
  state.head = head
}

export function setLatLng (state, value) {
  state.latLng = value
}

export function setName (state, value) {
  state.name = value
}

export function setDate (state, value) {
  if (value && value !== '') {
    state.date = moment(value).format('DD/MM/YYYY')
  } else {
    state.date = ''
  }
}

export function setPan (state, value) {
  state.pan = value
}

export function setPitch (state, value) {
  state.pitch = value
}

export function setRoll (state, value) {
  state.roll = value
}

export function setLaterals (state, value) {
  state.laterals = value
}

export function setSelectedLateral (state, value) {
  state.selectedLateral = value
}

export function setNeighbours (state, value) {
  state.neighbours = value
}

export function setFolderPanorama (state, value) {
  state.folderPanorama = value
}

export function setFolderPointCloud (state, value) {
  state.folderPointCloud = value
}

export function setFolderPanoramaCampaign (state, value) {
  state.folderPanoramaCampaign = value
}

export function setFolderLateralsCampaign (state, value) {
  state.folderLateralsCampaign = value
}

export function setFolderPointCloudCampaign (state, value) {
  state.folderPointCloudCampaign = value
}

export function setShowLateral (state, value) {
  state.showLateral = value
}

export function setShowPannellum (state, value) {
  state.showPannellum = value
}

export function setShowPotree (state, value) {
  state.showPotree = value
}

export function setResult (state, value) {
  state.result = value
}

export function setCampaigns (state, value) {
  state.campaigns = value
}

export function setSelectedCampaign (state, value) {
  state.selectedCampaign = value
}

export function setSelectedCategory (state, value) {
  state.selectedCategory = value
}

export function setScreenshot (state, value) {
  state.screenshot = value
}

export function setCurrentPointclouds (state, value) {
  state.currentPointclouds = value
}
